import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-politicas-uso-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './politicas-uso-popup.component.html',
  styleUrls: ['./politicas-uso-popup.component.scss'],
})
export class PoliticasUsoPopupComponent {
  constructor(public dialogRef: MatDialogRef<PoliticasUsoPopupComponent>) {}
  
  closeDialog(): void {
    this.dialogRef.close();
  }
}